import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { ELoyaltyProvider } from 'components/awards/enums';

const PREFIX = 'QrCodeBlock';

const classes = {
    root: `${PREFIX}root`,
    code: `${PREFIX}code`
};

const Root = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    [`& .${classes.root}`]: {
        backgroundColor: '#fff',
        borderRadius: theme.shape.borderRadius,
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1)
    },

    [`& .${classes.code}`]: {
        marginBottom: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    }
}));

interface QrCodeBlockProps {
    children: React.ReactChild;
    qrCodeValue: string;
    loyaltyProvider?: ELoyaltyProvider;
    showTitle?: boolean;
}

export const QrCodeBlock: React.FC<QrCodeBlockProps> = ({
    children,
    qrCodeValue,
    loyaltyProvider,
    showTitle
}) => {
    const { t } = useTranslation();

    return (
        <Root>
            {showTitle && (
                <Typography align="center" gutterBottom>
                    {t('DIALOG_BARCODE_MESSAGE')}
                </Typography>
            )}
            <Box p={3} pb={1} className={classes.root}>
                <div className={classes.code}>{children}</div>
                {loyaltyProvider !== ELoyaltyProvider.Powercard && (
                    <Typography align="center">{qrCodeValue}</Typography>
                )}
            </Box>
        </Root>
    );
};
